/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module PoolModule
 * @preferred
 */

import { NgModule } from '@angular/core';

import { PoolStateService } from './services/pool-state.service';

@NgModule({
    providers: [
        PoolStateService,
    ],
})
export class PoolModule {}
